import styled from 'styled-components'

import { pulseAnimate, PulseAnimateMode } from '~/styles/shared/pulseAnimate'

import { HeightClass } from '~/utils/enum/classes'

import ButtonRAW from '../Button'

export const Container = styled.div<{
  heightClass: HeightClass
  pulseAnimate?: PulseAnimateMode
  variant?: 'primary' | 'secondary'
}>`
  display: flex;

  button {
    &:disabled {
      border-style: dashed;
      cursor: not-allowed;
    }

    &:focus {
      border-color: #abbed1;
    }
  }

  ${({ pulseAnimate: mode }) => mode && pulseAnimate(mode, '#006bff', '0px')};

  border-radius: ${({ theme, heightClass }) =>
    theme.button.borderRadius?.[heightClass]};
`

export const Input = styled.input<{
  heightClass: HeightClass
}>`
  ${({ theme, heightClass }) =>
    `border: solid ${theme.button.border?.[heightClass]} #006bff;`};

  border-top-left-radius: ${({ theme, heightClass }) =>
    theme.button.borderRadius[heightClass]};
  border-bottom-left-radius: ${({ theme, heightClass }) =>
    theme.button.borderRadius[heightClass]};
  text-align: center;

  width: ${({ theme, heightClass }) => theme.button.heights[heightClass]};

  line-height: ${({ theme, heightClass }) =>
    theme.input[heightClass]?.lineHeight}px;

  font-size: ${({ theme, heightClass }) =>
    theme.input[heightClass]?.fontSize}px;

  color: #303032;

  &:focus {
    border-color: #abbed1;
    outline: none;
    z-index: 1;
  }

  &[tabIndex='-1'] {
    border-radius: 0;
  }

  &:disabled {
    border-style: dashed;
    cursor: not-allowed;
  }
`

export const Button = styled(ButtonRAW)`
  flex: 1;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -3px;
`
